import Page from "../pages/layout/espFramePage";

export default [
  {
    path: "/platform_billcode",
    name: "platform_billcode",
    redirect: "/platform_billcode/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "platform_billcode_index",
        meta: {title: "单号规则", isIndex: true, keepAlive: true},
        component: () => import("@/pages/platform/billcode/index")
      }
    ]
  },
  {
    path: "/platform_menu",
    name: "platform_menu",
    redirect: "/platform_menu/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "platform_menu_index",
        meta: {title: "菜单管理", isIndex: true, keepAlive: true},
        component: () => import("@/pages/platform/menu/index")
      }
    ]
  },
  {
    path: "/platform_quartz",
    name: "platform_quartz",
    redirect: "/platform_quartz/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "platform_quartz_index",
        meta: {title: "定时任务", isIndex: true, keepAlive: true},
        component: () => import("@/pages/platform/quartz/index")
      },
      {
        path: "log",
        name: "platform_quartz_log",
        meta: {title: "任务日志", isIndex: false, keepAlive: false},
        component: () => import("@/pages/platform/quartz/log")
      }
    ]
  },
  {
    path: "/platform_role",
    name: "platform_role",
    redirect: "/platform_role/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "platform_role_index",
        meta: {title: "角色管理", isIndex: true, keepAlive: true},
        component: () => import("@/pages/platform/role/index")
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/platform.js